import { useEffect } from "react";
import {
  MenuButtonBold,
  MenuButtonItalic,
  MenuButtonUnderline,
  MenuControlsContainer,
  RichTextEditor,
  MenuButtonTextColor,
  MenuSelectTextAlign,
  MenuButtonOrderedList,
  MenuButtonEditLink,
  LinkBubbleMenu,
  MenuButtonRedo,
  MenuButtonUndo,
  MenuDivider,
  MenuButtonBulletedList,
  TableBubbleMenu,
  MenuButtonAddTable,
} from "mui-tiptap";
import useExtensions from "./use-extensions";
import { setElementUpdated } from "../../utils/SingletonStore";

export default function TextEditor({ rteRef, htmlText }: any) {
  const extensions = useExtensions();

  useEffect(() => {
    if (htmlText) {
      rteRef.current.editor.commands.setContent(htmlText);
    } else {
      rteRef.current.editor.commands.setContent("");
    }
  }, [htmlText]); // eslint-disable-line

  return (
    <RichTextEditor
      sx={{
        width: "calc(100% - 100px)",
        "& .ProseMirror": {
          minHeight: "150px",
          maxHeight: "300px",
          overflowY: "auto",
          padding: 1,
        },
      }}
      ref={rteRef}
      extensions={extensions}
      content={htmlText ?? ""}
      onUpdate={({ editor }) => {
        const currentHTML = editor.getHTML();
        if (currentHTML !== htmlText) {
          setElementUpdated(true);
        }
      }}
      renderControls={() => (
        <MenuControlsContainer>
          <MenuButtonBold />
          <MenuButtonItalic />
          <MenuButtonUnderline />
          <MenuButtonTextColor
            defaultTextColor={"#000"}
            swatchColors={[
              { value: "#000000", label: "Black" },
              { value: "#ffffff", label: "White" },
              { value: "#888888", label: "Grey" },
              { value: "#ff0000", label: "Red" },
              { value: "#ff9900", label: "Orange" },
              { value: "#ffff00", label: "Yellow" },
              { value: "#00d000", label: "Green" },
              { value: "#0000ff", label: "Blue" },
            ]}
          />
          <MenuDivider />
          <MenuSelectTextAlign />
          <MenuButtonBulletedList />
          <MenuButtonOrderedList />
          <MenuButtonEditLink />
          <MenuButtonAddTable />
          <MenuDivider />
          <MenuButtonUndo />
          <MenuButtonRedo />
        </MenuControlsContainer>
      )}
    >
      {() => (
        <>
          <LinkBubbleMenu />
          <TableBubbleMenu />
        </>
      )}
    </RichTextEditor>
  );
}
